import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "../App.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const initialColumns = [
  { id: 1, title: "Fall Year 3", boxes: [] },
  { id: 2, title: "Winter Year 3", boxes: [] },
  { id: 3, title: "Fall Year 4", boxes: [] },
  { id: 4, title: "Winter Year 4", boxes: [] },
];

function CreatePlan() {
  const { id } = useParams();

  function generateRandomId() {
    const length = 7;
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomId = '';
  
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomId += characters.charAt(randomIndex);
    }
  
    return randomId;
  }

  const [PlanId, setPLanId] = useState("NULL");

  useEffect(() => {
    axios.get(process.env.REACT_APP_Apiurl +"planner/" + id).then((res) => {
      console.log(res.data);

      for(let i = 0; i < res.data.courses.length; i++){
        const newBox = {
          id: res.data.courses[i].id,
          code: res.data.courses[i].course_code,
          name: res.data.courses[i].course_name,
          column: res.data.courses[i].column_id,
        };
        const updatedColumns = [...columns];
        updatedColumns[res.data.courses[i].column_id].boxes.push(newBox); // Add new box to the first column
        setColumns(updatedColumns);
      }
    });
  }, []);

  const [columns, setColumns] = useState(initialColumns);
  const [draggedBox, setDraggedBox] = useState(null);
  const [courseCode, setCourseCode] = useState("");
  const [courseName, setCourseName] = useState("");
  const contentRef = useRef(null);
  const [hoveredBox, setHoveredBox] = useState(null);
  const [fadeInItems, setFadeInItems] = useState(false);

  useEffect(() => {
    // Simulate sequential loading with a delay
    const timeout = setTimeout(() => {
      setFadeInItems(true);
    }, 500); // Adjust delay as needed

    return () => clearTimeout(timeout);
  }, []);

  const handleMouseEnter = (boxId) => {
    setHoveredBox(boxId);
  };

  const handleMouseLeave = () => {
    setHoveredBox(null);
  };

  const handleDragStart = (box, columnIndex) => {
    setDraggedBox({ box, fromColumn: columnIndex });
  };

  const handleDrop = (toColumnIndex) => {
    if (draggedBox) {
      const { box, fromColumn } = draggedBox;
      if (fromColumn === toColumnIndex) {
        setDraggedBox(null);
        return;
      }

      if (toColumnIndex !== 0 && columns[toColumnIndex].boxes.length >= 6) {
        setDraggedBox(null);
        alert("This column is full, remove a course to add another course");
        return;
      }

      const updatedColumns = columns.map((column, index) => {
        if (index === fromColumn) {
          return {
            ...column,
            boxes: column.boxes.filter((b) => b.id !== box.id),
          };
        }
        if (
          index === toColumnIndex &&
          (toColumnIndex === 0 || column.boxes.length < 6)
        ) {
          return {
            ...column,
            boxes: [...column.boxes, box],
          };
        }
        return column;
      });

      axios.post(process.env.REACT_APP_Apiurl +"updateBox", {boxid: draggedBox.box.id, column: toColumnIndex}).then((res) => {
            
        });

      setColumns(updatedColumns);
      setDraggedBox(null);
    }
  };

  const addBox = () => {
    if (courseCode !== "" && courseName !== "") {
      let insertID = 0;

      while (columns[insertID].boxes.length >= 6) {
        insertID++;
        if (insertID > 3) {
          alert("Remove a course to add more");
        }
      }

      if (columns[insertID].boxes.length < 6) {
        const newBox = {
          id: generateRandomId(),
          code: courseCode,
          name: courseName,
          column: insertID,
        };
        const updatedColumns = [...columns];
        updatedColumns[insertID].boxes.push(newBox);
        setColumns(updatedColumns);
        setCourseCode("");
        setCourseName("");

        axios.post(process.env.REACT_APP_Apiurl +"addBox/" + id, newBox).then((res) => {

        });

      } else {
        alert(
          "First column already has 6 boxes. Move some boxes to other columns first."
        );
      }
    } else {
      alert("Cannot enter empty course code and name");
    }
  };

  const deleteBox = (columnIndex, boxId) => {
    const updatedColumns = [...columns];
    updatedColumns[columnIndex].boxes = updatedColumns[
      columnIndex
    ].boxes.filter((box) => box.id !== boxId);
    setColumns(updatedColumns);
    axios.post(process.env.REACT_APP_Apiurl +"deleteBox", {boxid:boxId}).then((res) => {

        });
  };

  const handleClick = () => {
    window.location.href = process.env.REACT_APP_App_Url
  };

  const downloadPDF = () => {
    // Create an instance of jsPDF
    const doc = new jsPDF();

    // Get the content area to convert to PDF
    const content = contentRef.current;

    // Use html2canvas to convert content to an image (canvas)
    html2canvas(content).then((canvas) => {
      // Get the data URL representing the canvas
      const imgData = canvas.toDataURL("image/png");

      // Add the image (canvas) to PDF
      const imgHeight = (canvas.height * 208) / canvas.width; // 208mm is approximately equal to 297mm (A4 size) in pixels
      doc.addImage(imgData, "PNG", 0, 0, 208, imgHeight);

      // Save the PDF file
      doc.save("columns.pdf");
    });
  };

  return (
    <div className="flex-row min-h-[100vh] p-10 bg-[#121212]">
      <div className="text-center mb-6">
        <h1 onClick={handleClick} className="hover:cursor-pointer text-3xl text-white">
          Basic Course Planner
        </h1>
      </div>
      <div className="grow flex justify-center mb-10">
        <div className="items-center bg-[#C8E1F91A] p-5 rounded-lg">
          <input
            type="text"
            placeholder="Course Code"
            value={courseCode}
            onChange={(e) => setCourseCode(e.target.value)}
            className="mr-4 p-2 border rounded border-[#BCD6F00A] bg-[#C3DEFE33] focus:outline-none focus:text-white"
          />
          <input
            type="text"
            placeholder="Course Name"
            value={courseName}
            onChange={(e) => setCourseName(e.target.value)}
            className="mr-4 p-2 border border-[#BCD6F00A] rounded bg-[#C3DEFE33] focus:border-0 focus:outline-none focus:text-white"
          />
          <a
            onClick={addBox}
            href="#_"
            className="inline-flex items-center justify-center h-10 px-3 py-0 text-sm font-semibold text-center text-gray-200 no-underline align-middle transition-all duration-300 ease-in-out bg-transparent border-2 border-gray-600 border-solid rounded-lg cursor-pointer select-none hover:text-[#FFD700] hover:border-[#FFD700] focus:shadow-xs focus:no-underline"
          >
            Add Course
          </a>
        </div>
        <div className="grow ml-4 items-center flex-row text-center bg-[#C8E1F91A] p-5 rounded-lg">
          <p className="text-white">Course Plan ID:</p>
          <p className="text-white font-bold text-xl">{id}</p>
        </div>
      </div>

      <div className="rounded-lg p-1 min-h-[70vh] overflow-y-auto flex flex-row justify-between space-x-4">
        {columns.map((column, columnIndex) => (
          <div
            key={column.id}
            className={`column flex-1 p-2 max-h-[70vh] overflow-y-auto bg-[#C8E1F91A] rounded-md ${fadeInItems ? "animate-fade-in transition-opacity duration-1000 ease-in-out" : "opacity-0"}`}
            style={{ transitionDelay: `${200 + columnIndex * 100}ms` }}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => handleDrop(columnIndex)}
          >
            <h2 className="text-gray-300 text-center text-xl font-bold mb-1 select-none">
              {column.title}
            </h2>
            <p className="text-[#D4AF37] text-center text-sm font-semi mb-1 select-none">
              {column.boxes.length} Courses
            </p>
            {column.boxes.map((box, i) => (
              <div
                key={i}
                className="box bg-[#A9A9A9] border border-[#BCD6F00A] p-3 px-4 rounded shadow-lg mb-4 relative"
                draggable
                onDragStart={() => handleDragStart(box, columnIndex)}
                onMouseEnter={() => handleMouseEnter(box.id)}
                onMouseLeave={handleMouseLeave}
              >
                <strong>{box.code}</strong>
                <p className="text-sm text-gray-800">{box.name}</p>
                {hoveredBox === box.id && (
                  <button
                    onClick={() => deleteBox(columnIndex, box.id)}
                    className="absolute top-2 right-2 px-2 py-1 text-red-500"
                  >
                    X
                  </button>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default CreatePlan;
